let $store__gallery_home = $(".store__gallery_home.mb").flickity({
  contain: true,
  groupCells: true,
  cellAlign: "center",
  prevNextButtons: true,
  pageDots: true,
  draggable: true,
  fade: true,
  lazyLoad: 1,
  arrowShape: {
    x0: 10,
    x1: 60,
    y1: 50,
    x2: 60,
    y2: 40,
    x3: 20,
  },
});

$store__gallery_home.on("select.flickity", function (event, index) {
  $.each($(".button-group .button__nav"), function (i, l) {
    $(l).removeClass("current");
  });
  var id = index + 1;
  $("#nav--" + id).addClass("current");
});

$(".button-group").on("click", ".button__nav", function () {
  $.each($(".button-group .button__nav"), function (i, l) {
    $(l).removeClass("current");
  });
  var index = $(this).index();
  $store__gallery_home.flickity("select", index);
  var id = index + 1;
  $("#nav--" + id).addClass("current");
});

let $store__gallery_pc = $(".store__gallery.pc").flickity({
  contain: true,
  groupCells: true,
  cellAlign: "left",
  prevNextButtons: true,
  pageDots: true,
  draggable: true,
  fade: true,
  lazyLoad: 1,
  arrowShape: {
    x0: 10,
    x1: 60,
    y1: 50,
    x2: 60,
    y2: 40,
    x3: 20,
  },
});

// Lắng nghe sự kiện 'resize' trên cửa sổ
window.addEventListener("resize", function () {
  // Gọi phương thức 'resize' của Flickity
  $store__gallery_pc.flickity("resize");
});

$store__gallery_pc.on("select.flickity", function (event, index) {
  $.each($(".button-group .button__nav"), function (i, l) {
    $(l).removeClass("current");
  });
  var id = index + 1;
  $("#nav--" + id).addClass("current");
});

$(".button-group").on("click", ".button__nav", function () {
  $.each($(".button-group .button__nav"), function (i, l) {
    $(l).removeClass("current");
  });
  var index = $(this).index();
  $store__gallery_pc.flickity("select", index);
  var id = index + 1;
  $("#nav--" + id).addClass("current");
});

const myTimeout = setTimeout(setCss, 1500);

function setCss() {
  const imgs = document.querySelectorAll(".store__gallery .store__image");
  imgs.forEach((img) => {
    img.style.height = "100%";
  });
  clearTimeout(myTimeout);
}
document.body.addEventListener(
  "CollectionFilterRendered",
  () => {
    let $store__gallery_pc = $(".store__gallery.pc").flickity({
      contain: true,
      groupCells: true,
      cellAlign: "left",
      prevNextButtons: true,
      pageDots: true,
      draggable: true,
      fade: true,
      lazyLoad: 1,
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 60,
        y2: 40,
        x3: 20,
      },
    });

    $store__gallery_pc.on("select.flickity", function (event, index) {
      $.each($(".button-group .button__nav"), function (i, l) {
        $(l).removeClass("current");
      });
      var id = index + 1;
      $("#nav--" + id).addClass("current");
    });
  },
  { once: false }
);

$(document).ready(function () {
  if (window.matchMedia("(max-width: 1110px)").matches) {
    $(".flickity-enabled.is-draggable .flickity-viewport").addClass(
      "force-height"
    );
  } else if (
    window.matchMedia("(min-width: 1110px) and (max-width: 1260px)").matches
  ) {
    $(".flickity-enabled.is-draggable .flickity-viewport").addClass(
      "force-height"
    );
  } else if (window.matchMedia("(min-width: 1240px)").matches) {
    $(".flickity-enabled.is-draggable .flickity-viewport").removeClass(
      "force-height"
    );
  } else {
    $(".flickity-enabled.is-draggable .flickity-viewport").removeClass(
      "force-height"
    );
  }
});
